import './i18n';
import { useRoutes } from 'react-router';
import routes, { generateRoutes } from './routes/routes';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScrollProvider } from '@/context/ScrollContext';
import { lazy, useEffect } from 'react';
import Header from './components/PageContainer/Header';
import Footer from './components/PageContainer/Footer';
import appConfig from './utils/appConfig';

const FloatingChatbot = lazy(() => import('@/components/PageContainer/FloatingChatbot'));

const FloatingPhone = lazy(() => import('@/components/PageContainer/FloatingPhone'));

const App = () => {
  const element = useRoutes(generateRoutes(routes));
  const { i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <Box display='flex' flex={1} style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      <ScrollProvider>
        <Box component='main' width='100%' dir={isRtl ? 'rtl' : 'ltr'}>
          <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            {element}
            <Footer />
            <FloatingPhone />
            {appConfig.HAS_CHATBOT && <FloatingChatbot />}
          </Box>
        </Box>
      </ScrollProvider>
    </Box>
  );
};

export default App;
